module.exports = __webpack_public_path__ + "static/media/de_vertigo.1f22409d.jpg";